import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import PropertyForm from "../AddProperty/PropertyForm";
import { addProperty } from "../../../services/api";
import "./AddProperty.css";

export default function AddProperty() {
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);

  const onSubmit = async (payload) => {
    setSaving(true);
    try {
      const res = await addProperty(payload);
      toast.success(res.message || "Property added successfully");
      navigate("/admin/property-list");
    } catch (err) {
      toast.error(err.message || "Failed to save property");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="ap">
      <div className="ap-eyebrow">Inventory</div>
      <h1 className="ap-title">Add Property</h1>
      <p className="ap-sub">Create a new project listing in six guided steps.</p>
      <div className="ap-form">
        <PropertyForm onSubmit={onSubmit} submitting={saving} />
      </div>
    </div>
  );
}